var indicator = function (column) {
    var $column = column.$el;
    $column.find('.ac-column-header [data-indicator-toggle]').each(function () {
        var $ = jQuery;
        var $indicator = $(this);
        var setting = $(this).data('setting');
        var $setting = $column.find('.ac-column-setting[data-setting=' + setting + ']');
        var $input = $setting.find('.col-input:first .ac-setting-input:first input[type=radio]');
        $indicator.unbind('click').on('click', function (e) {
            e.preventDefault();
            if ($column.hasClass('disabled')) {
                return;
            }
            $indicator.toggleClass('on');
            if ($(this).hasClass('on')) {
                $input.filter('[value=on]').prop('checked', true).trigger('click').trigger('change');
            }
            else {
                $input.filter('[value=off]').prop('checked', true).trigger('click').trigger('change');
            }
        });
        $input.on('change', function () {
            if ($column.hasClass('disabled')) {
                return;
            }
            var value = $input.filter(':checked').val();
            if ('on' === value) {
                $indicator.addClass('on');
            }
            else {
                $indicator.removeClass('on');
            }
        });
    });
};
export default indicator;
